import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGitContext } from "./ModelContext.tsx";

export function DuplicateGitDialog() {
  const git = useGitContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Duplicate git?"
      description={`${git.name} will be duplicated. Plop!`}
      submitLabel="Duplicate"
      onSubmit={async () => {
        const nextGit = git.gang.duplicateGit(git);
        const result = await database.gangs.updateOne(nextGit.gang.data);
        return result.mapSuccess((gangId) => ({ gangId, gitId: nextGit.id }));
      }}
      onSuccess={({ gangId, gitId }) => {
        toast("Git duplicated");
        navigate(`~/gangs/g/${gangId}/g/${gitId}`);
      }}
    />
  );
}
